
import request from '@/request'
const part_url = '/train/web/examination/';


/**
 * 查看考试详情
 *
 * @param {*} examinationId 考试ID
 * @returns
 */
function getArticleExaminationDetail(data) {
  let url = part_url + "getArticleExaminationDetail";
  return request.get(url, data)
}


/**
 * 开始考试获取题目
 * @param {*} examinationId 考试id
 * @param {*} testpaperId 试卷id
 * @param {*} type 考试模式    1 练习模式 2 考试模式
 * @returns
 */
function getStartArticleExamination(data) {
  let url = part_url + "startArticleExamination";
  return request.get(url, data)
}
/**
 * 记录答案
 *
 * @param {*} examId 考试ID
 * @param {*} examArticleId 主考试ID
 * @param {*} subjectId 题目ID
 * @param {*} answer 答案
 * @param {*} type 类型 examination 考试、practiceExam 模拟考试
 * @returns
 */
function answerArticleProcess(data) {
  let url = part_url + "answerArticleProcess";
  return request.get(url, data)
}

/**
 * 移除文件
 * @param data
 * @returns {Promise<unknown | void>}
 */
function removeAnswer(data) {
  let url = part_url + "removeAnswer";
  return request.get(url, data)
}

/**
 * 校验考试是否可以进行
 *
 * @param {*} examinationId 考试ID
 * @returns
 */
function checkArticleExamination(data) {
  let url = part_url + "checkArticleExamination";
  return request.get(url, data)
}

function getTestPaperInfo(data) {
  let url = part_url + "getTestPaperInfo";
  return request.get(url, data)
}

export default {
  getArticleExaminationDetail,
  getStartArticleExamination,
  answerArticleProcess,
  checkArticleExamination,
  getTestPaperInfo,
  removeAnswer
}



// WEBPACK FOOTER //
// ./src/api/articleExam.js